import React from 'react';
import { DetailPanelData } from '../../../Common/DetailPanel';
import { renderWeight } from '../../../../Utils/weight_utils';

const RefrigerantInformation = ({
    data: {
        materialClass = '',
        chargeCapacityDeterminedByName,
        currentGasWeightLBS
    } = {},
}) => {
    return (
        <>
            {materialClass !== '' && <DetailPanelData id='materialClassHeader' title="MATERIAL CLASS" data={materialClass} />}
            <DetailPanelData id='currentGasWeight' title="CURRENT GAS WEIGHT" data={renderWeight(currentGasWeightLBS)}  />
            <DetailPanelData id='chargeCapaciityDeterminedByHeader' title="CHARGE CAPACITY DETERMINED BY" data={chargeCapacityDeterminedByName} />
        </>
    )
}

export default RefrigerantInformation;